import * as tslib_1 from "tslib";
import { AfterContentInit, ChangeDetectorRef, OnInit, } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UUID } from 'angular2-uuid';
import { Subject, Subscription } from 'rxjs';
import { HeaderOnboardingComponent } from './shared/components/header/header-onboarding.component';
import { CHANNEL } from './shared/constants/channel.constants';
import { StepBiocatchEnum, StepBiocatchEnumFirmlyApproved, } from './shared/enums/biocatchContext.enum';
import { OpEnum } from './shared/enums/op.enum';
import { AbreCuentasService } from './shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from './shared/services/bitacora/bitacora.service';
import { ChannelCommunicatorService } from './shared/services/communicator/channel-communicator/channel-communicator.service';
import { PlatformCommunicatorAuthService } from './shared/services/communicator/platform-communicator/platform-communicator.auth.service';
import { SSOInformation } from './shared/services/communicator/security/sso/sso-information.model';
import { SsoService } from './shared/services/communicator/security/sso/sso.service';
import { BioCatchService } from './shared/services/external/biocatch/biocatch.service';
import { CryptoVaultService } from './shared/services/external/crypto-vault/crypto-vault.service';
import { FirmlyApprovedService } from './shared/services/firmly-approved/firmly-approved.service';
import { HeaderService } from './shared/services/header/header.service';
import { LoadingService } from './shared/services/loading/loading.service';
import { NavigationService } from './shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from './shared/services/parameters/parameters.service';
import { RequestService } from './shared/services/request/request-onboarding.service';
import { TaggingService } from './shared/services/tagging/tagging.service';
import { PopupService } from './shared/services/popup/popup.service';
import { ConfigurationService } from './shared/services/configuration/configuration.service';
import { takeUntil } from 'rxjs/operators';
var deviceInfo = {
    device_id: '',
    os_version: '',
    brand: '',
    model: '',
};
/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
var AppComponent = /** @class */ (function () {
    /**
     * Summary      Constructor of the component.
     *
     * @param {AbreCuentasService}          abreCuentasService          Injectable abreCuentasService service.
     * @param {NavigationService}           navigationService           Injectable navigationService angular router.
     * @param {BioCatchService}             bioCatchService             Injectable bioCatchService service.
     * @param {ChannelCommunicatorService}  channelCommunicatorService  Injectable channelCommunicatorService service.
     * @param {ParametersService}           parametersService           Injectable parametersService service.
     * @param {LoadingService}              loadingService              Injectable loadingService service.
     * @function setLoadingSubscribe
     * @function setHeaderSubscribe
     */
    function AppComponent(abreCuentasService, navigationService, bioCatchService, channelCommunicatorService, parametersService, loadingService, headerService, domSanitizer, taggingService, ssoService, authService, requestService, cipherService, cdRef, bitacoraService, firmlyApprovedService, popupService, configurationService) {
        this.abreCuentasService = abreCuentasService;
        this.navigationService = navigationService;
        this.bioCatchService = bioCatchService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.parametersService = parametersService;
        this.loadingService = loadingService;
        this.headerService = headerService;
        this.domSanitizer = domSanitizer;
        this.taggingService = taggingService;
        this.ssoService = ssoService;
        this.authService = authService;
        this.requestService = requestService;
        this.cipherService = cipherService;
        this.cdRef = cdRef;
        this.bitacoraService = bitacoraService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.popupService = popupService;
        this.configurationService = configurationService;
        /**
         * Declaración de la variable showLoading como falso
         *
         * *Set showLoading variable as false*
         *
         * @access              public
         * @type                {boolean}
         */
        this.showLoading = false;
        /**
         * Declaración de la variable header como IHeader
         *
         * *Set header variable as IHeader*
         *
         * @access              public
         * @type                {string}
         */
        this.header = {
            show: false,
        };
        /**
         * variable that get the details if the feature is called of details
         */
        this.states = {
            isIos: false,
            isAndroid: false,
        };
        this.isIpadPro = false;
        this._subscriber$ = new Subject();
        this.channelId = '0';
        this.showPopup = false;
        this.DSBinitCheck = false;
        this.DSBisSecureByRiskRules = false;
        this.DSBisSecureCertificate = false;
        this.dsbConnectionAttempts = 0;
        if (navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform)) {
            this.isIpadPro = true;
        }
        this.states.isIos =
            navigator.userAgent !== undefined &&
                (/(iPhone|iPod|iPad).*AppleWebKit(?!state.*Safari)/i.test(navigator.userAgent)
                    || this.isIpadPro);
        this.states.isAndroid =
            navigator.userAgent !== undefined && /android/i.test(navigator.userAgent);
        deviceInfo.os_version = this.getDeviceInfoOsVersion();
        this.abreCuentasService.setDeviceInfo(deviceInfo);
        this.transactionId = UUID.UUID();
        this.abreCuentasService.setTransactionId(this.transactionId);
        this.setLoadingSubscribe();
        this.setHeaderSubscribe();
    }
    /**
     * Establece el valor para deviceInfo.os_version
     *
     * get the value for deviceInfo.os_version
     */
    AppComponent.prototype.getDeviceInfoOsVersion = function () {
        return this.states.isIos === true ? 'iOS' : 'Android';
    };
    // ngAfterViewChecked() {
    //   this.setHeaderSubscribe();
    // }
    /**
     * Muestra el estado de carga genérico de la aplicación y valida el canal de comunicación una vez el componente es cargado
     *
     * *Shows app generic loading state and validates communication channel once the component is loaded*
     */
    AppComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isUserJemelii;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                isUserJemelii = this.abreCuentasService.getQueryParamByName('userJemelii', window.location.search);
                console.log('userJemelii', this.abreCuentasService.getQueryParamByName('userJemelii', window.location.search));
                if (isUserJemelii && isUserJemelii == 'true') {
                    this.abreCuentasService.setUserJemelii(true);
                }
                else {
                    this.abreCuentasService.setUserJemelii(false);
                }
                this.popupService.popupState.subscribe(function (resp) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        this.showPopup = resp.showPopup;
                        return [2 /*return*/];
                    });
                }); }, 
                // tslint:disable-next-line
                function (error) {
                    console.error('Error getting popup state:', error);
                });
                this.init();
                return [2 /*return*/];
            });
        });
    };
    AppComponent.prototype.init = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ssoParameters, ssoResponse;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.channelCommunicatorService.validateChannel()];
                    case 1:
                        _a.sent();
                        this.channelId = this.channelCommunicatorService.getChannelId();
                        this.isPostLogin = this.abreCuentasService.getPostlogin();
                        this.validateClientType();
                        if (!!this.isPostLogin) return [3 /*break*/, 5];
                        ssoParameters = this.parametersService.getParameter('security_sso');
                        return [4 /*yield*/, this.ssoService.enableAPIGateway(ssoParameters.login.grant_type, ssoParameters.login.client_id, ssoParameters.login.client_secret)];
                    case 2:
                        ssoResponse = _a.sent();
                        if (!ssoResponse) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.keyCipherExchange()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, this.getObjectData('3')];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype.validateClientType = function () {
        if (!this.isPostLogin
            && this.channelCommunicatorService.getChannelId() === CHANNEL.SUPERAPP.CODE) {
            this.abreCuentasService.setIsNewClient(true);
        }
        else {
            this.abreCuentasService.setIsNewClient(false);
        }
    };
    AppComponent.prototype.getSettings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestService.getSettingsConfig('onboarding-fe-settings').then(function (data) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.parametersService.loadApplicationSettings(data)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.requestService.getSettingsConfig('onboarding-co.tagging.service').then(function (data) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.abreCuentasService.setTaggeo(data.data)];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getDistrict()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Realiza la negociación de las llaves para el servicio de cryptoVault
     *
     * Negotiates the keys for cryptoVault service
     */
    AppComponent.prototype.keyCipherExchange = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.warn('Entró en App.component por keyCipherExchange ------');
                        if (!this.transactionId) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.cipherService.keyExchange(this.transactionId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.cipherService.refreshKeyCrypto()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.requestService
                                .getSessionId()
                                .then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            this.authService.saveSessionId(response.body.session_id);
                                            return [4 /*yield*/, this.getSettings()];
                                        case 1:
                                            _a.sent();
                                            return [4 /*yield*/, this.biocatchInit()];
                                        case 2:
                                            _a.sent();
                                            if (!(this.abreCuentasService.getUserJemelii() && !this.isPostLogin)) return [3 /*break*/, 4];
                                            return [4 /*yield*/, this.getObjectDataForJemelli('3')];
                                        case 3:
                                            _a.sent();
                                            _a.label = 4;
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); })
                                .catch(function () {
                                _this.navigationService.navigateToGeneralInformation('600');
                            })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype.biocatchInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var biocatchConfig, csid, initialContext;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        biocatchConfig = this.channelId === CHANNEL.SUPERAPP.CODE
                            ? this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_BIOCATCH_CONFIGS_APPUNICA)
                            : CHANNEL.PORTALALLIES.CODE
                                ? this.parametersService.getSetting(OpEnum.ALLIES_BIOCATCH_CONFIG)
                                : this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_BIOCATCH_CONFIGS);
                        // this.abreCuentasService.setCSID(this.authService.getSessionId());
                        if (this.channelId !== CHANNEL.SUPERAPP.CODE && !this.isPostLogin) {
                            csid = void 0;
                            if (this.channelId === CHANNEL.PORTALALLIES.CODE) {
                                csid = this.authService.getSessionId();
                            }
                            else {
                                csid = getCsidPortal();
                            }
                            this.abreCuentasService.setCSID(csid);
                        }
                        this.abreCuentasService.setBioCatchConfig(biocatchConfig);
                        initialContext = !this.isPostLogin && this.channelId === CHANNEL.SUPERAPP.CODE
                            ? StepBiocatchEnum.solicitud
                            : this.isPostLogin && !this.firmlyApprovedService.isEmpty()
                                ? StepBiocatchEnumFirmlyApproved.solicitud_aprobado_firme
                                : StepBiocatchEnum.productos;
                        return [4 /*yield*/, this.bioCatchService.init(initialContext, this.channelId, this.isPostLogin)];
                    case 1:
                        _a.sent();
                        this.bioCatchService.getPpidIsReady().pipe(takeUntil(this._subscriber$)).subscribe(function (isReady) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var bitacoraEvent;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!isReady) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.initApp()];
                                    case 1:
                                        _a.sent();
                                        if (this.isPostLogin) {
                                            bitacoraEvent = this.abreCuentasService.getCSID();
                                            this.bitacoraService.saveDataInBitacora(bitacoraEvent, true);
                                        }
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Obtiene el token del nativo para los flujos de cliente existente
     *
     * Get native token to postlogin flow
     */
    AppComponent.prototype.getObjectData = function (item) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ssoInformation, object, saveData, saveDataJson, saveDataJson;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('Iniciando GetObjectData');
                        if (!this.states.isAndroid) return [3 /*break*/, 8];
                        return [4 /*yield*/, getObjectData(item)];
                    case 1:
                        object = _a.sent();
                        ssoInformation = new SSOInformation(JSON.parse(object).token);
                        this.abreCuentasService.setCSID(JSON.parse(object).csid);
                        this.abreCuentasService.setIp(JSON.parse(object).address);
                        this.authService.saveSSOInformation(ssoInformation);
                        this.authService.saveSSOTokenForOTP(ssoInformation);
                        return [4 /*yield*/, getObjectData('4')];
                    case 2:
                        saveData = _a.sent();
                        if (!saveData) return [3 /*break*/, 6];
                        if (!(typeof saveData == 'string')) return [3 /*break*/, 4];
                        saveDataJson = JSON.parse(saveData).saveData;
                        return [4 /*yield*/, this.getOfferChannelApp(saveDataJson)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        saveDataJson = saveData.saveData;
                        return [4 /*yield*/, this.getOfferChannelApp(saveDataJson)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [4 /*yield*/, this.keyCipherExchange()];
                    case 7:
                        _a.sent();
                        return [3 /*break*/, 12];
                    case 8:
                        if (!(this.states.isIos === true)) return [3 /*break*/, 10];
                        return [4 /*yield*/, getObjectData(item)
                                .then(function (resultIos) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var saveData, saveDataJson, saveDataJson;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            ssoInformation = new SSOInformation(resultIos.token);
                                            this.abreCuentasService.setCSID(resultIos.csid);
                                            this.abreCuentasService.setIp(resultIos.address);
                                            this.authService.saveSSOInformation(ssoInformation);
                                            this.authService.saveSSOTokenForOTP(ssoInformation);
                                            return [4 /*yield*/, getObjectData('4')];
                                        case 1:
                                            saveData = _a.sent();
                                            if (!saveData) return [3 /*break*/, 5];
                                            if (!(typeof saveData == 'string')) return [3 /*break*/, 3];
                                            saveDataJson = JSON.parse(saveData).saveData;
                                            return [4 /*yield*/, this.getOfferChannelApp(saveDataJson)];
                                        case 2:
                                            _a.sent();
                                            return [3 /*break*/, 5];
                                        case 3:
                                            saveDataJson = saveData.saveData;
                                            return [4 /*yield*/, this.getOfferChannelApp(saveDataJson)];
                                        case 4:
                                            _a.sent();
                                            _a.label = 5;
                                        case 5: return [4 /*yield*/, this.keyCipherExchange()];
                                        case 6:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })
                                .catch(function (error) {
                                console.log('error en javascript...', error);
                            })];
                    case 9:
                        _a.sent();
                        return [3 /*break*/, 12];
                    case 10:
                        this.abreCuentasService.setIsPortal(true);
                        return [4 /*yield*/, this.channelCommunicatorService
                                .getImpl()
                                .getObjectDataPortal()
                                .then(function (tokenResult) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var csid, data;
                                var _this = this;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            ssoInformation = new SSOInformation(tokenResult.data.token);
                                            this.authService.saveSSOInformation(ssoInformation);
                                            this.authService.saveSSOTokenForOTP(ssoInformation);
                                            csid = getCsidPortal();
                                            data = csid === null || csid === undefined ? 'null' : csid;
                                            this.abreCuentasService.setCSID(data);
                                            this.abreCuentasService.setIp(tokenResult.data.address);
                                            /**
                                             * Cargue de los datos de la vitrina de Aprobados en Firme
                                             */
                                            return [4 /*yield*/, this.channelCommunicatorService
                                                    .getImpl()
                                                    .getFirmlyApprovedPortal()
                                                    .then(function (additionalData) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                                    return tslib_1.__generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0:
                                                                if (!additionalData.data) return [3 /*break*/, 2];
                                                                console.warn('Entrando por FirmlyApproved: ', additionalData);
                                                                return [4 /*yield*/, this.validateAdditionalData(additionalData.data)];
                                                            case 1:
                                                                _a.sent();
                                                                _a.label = 2;
                                                            case 2: return [2 /*return*/];
                                                        }
                                                    });
                                                }); })];
                                        case 1:
                                            /**
                                             * Cargue de los datos de la vitrina de Aprobados en Firme
                                             */
                                            _a.sent();
                                            return [4 /*yield*/, this.keyCipherExchange()];
                                        case 2:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 11:
                        _a.sent();
                        _a.label = 12;
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype.getObjectDataForJemelli = function (item) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ssoInformation, object;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('Iniciando GetObjectData FOR JEMELLI');
                        if (!this.states.isAndroid) return [3 /*break*/, 2];
                        return [4 /*yield*/, getObjectData(item)];
                    case 1:
                        object = _a.sent();
                        ssoInformation = new SSOInformation(JSON.parse(object).token);
                        this.authService.saveSSOTokenForOTP(ssoInformation);
                        return [3 /*break*/, 6];
                    case 2:
                        if (!(this.states.isIos === true)) return [3 /*break*/, 4];
                        return [4 /*yield*/, getObjectData(item)
                                .then(function (resultIos) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    console.log('RESPUESTA OBJECT DATA JEMELLI...', resultIos);
                                    ssoInformation = new SSOInformation(resultIos.token);
                                    this.authService.saveSSOTokenForOTP(ssoInformation);
                                    return [2 /*return*/];
                                });
                            }); })
                                .catch(function (error) {
                                console.log('error en javascript...', error);
                            })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        this.abreCuentasService.setIsPortal(true);
                        return [4 /*yield*/, this.channelCommunicatorService
                                .getImpl()
                                .getObjectDataPortal()
                                .then(function (tokenResult) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    ssoInformation = new SSOInformation(tokenResult.data.token);
                                    this.authService.saveSSOTokenForOTP(ssoInformation);
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Función que permite validar si los parámetros que recibe son
     * de Aprobados En Firme o son para inicializar el flujo.
     * @param {any} data - Parámetros a validar.
     */
    AppComponent.prototype.validateAdditionalData = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.warn('Datos recibidos: ', data);
                        if (!(data && data.offerType !== '')) return [3 /*break*/, 3];
                        if (!(data.id === undefined || data.id === 0)) return [3 /*break*/, 1];
                        console.warn('<<<<<<<<<<<<<<<< Entró por nuevo flujo CE >>>>>>>>>>>>>>>>>>>>>>>>');
                        this.productPreselected = data.offerType;
                        return [3 /*break*/, 3];
                    case 1:
                        console.warn('<<<<<<<<<<<<<<<< Entró por flujo FirmlyApproved >>>>>>>>>>>>>>>>>>>>>>>>');
                        return [4 /*yield*/, this.setDataOffer_FirmlyApproved(data)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Función que permite cargar el Id de la Oferta que llega desde
     * el chasis del canal de App (Android & IOs)
     * @param {any} firmlyApprovedResult - Objeto de la vitrina del Aprobado en Firme que llega desde canal con la siguiente estructura:
     * {
     *  offerId - Id de la oferta publicada en la vitrina
     *  offerType - Tipo de la oferta publicada en la vitrina
     * }
     */
    AppComponent.prototype.getOfferChannelApp = function (firmlyApprovedResult) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                console.warn('Entrando por FirmlyApproved: ', firmlyApprovedResult);
                if (firmlyApprovedResult && firmlyApprovedResult !== '') {
                    data = JSON.parse(firmlyApprovedResult);
                    this.validateAdditionalData(data);
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Función que permite guardar los datos de la Oferta del Aprobado En Firme que viene desde Portal
     * @param {any} firmlyApprovedPortal - Datos recibidos desde caada Canal del Aprobado En Firme
     */
    AppComponent.prototype.setDataOffer_FirmlyApproved = function (firmlyApprovedPortal) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dataOffer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dataOffer = {
                            offerId: firmlyApprovedPortal.id,
                            offerType: firmlyApprovedPortal.offerType,
                        };
                        this.firmlyApprovedService.setOffer_Channel(dataOffer);
                        return [4 /*yield*/, this.firmlyApprovedService.getProductsOffer()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Define la clase principal de la aplicación una vez el contenido es cargado
     *
     * *Sets main class for the application once the content is loaded*
     *
     */
    AppComponent.prototype.ngAfterContentInit = function () {
        this.setMainClass();
    };
    // /**
    //  * Ejecuta la función initApp una vez la vista es cargado
    //  *
    //  * *Runs initApp function once the view is loaded*
    //  *
    //  */
    // async ngAfterViewInit() {
    //   // await this.initApp();
    //   // console.log('ngaferview')
    // }
    /**
     * Deshace las subscripcione del estado de carga y header una vez el componente se detruye
     *
     * *Unsubscribtion of loading state and header componente once the component is destroyed*
     */
    // tslint:disable-next-line
    AppComponent.prototype.ngOnDestroy = function () {
        this.loadingSubscription.unsubscribe();
        this.headerSubscription.unsubscribe();
    };
    /* istanbul ignore next */
    /**
     * Inicializa las configuraciones necesarias para la aplicación
     * *Set up mandatory configuration of the app*
     *
     */
    AppComponent.prototype.initApp = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.abreCuentasService.setAbreCuentasConfigs(this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_CONFIGS)[0]);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.taggingService.initAnalytics()];
                    case 2:
                        _a.sent();
                        this.abreCuentasService.setBytteConfig(this.parametersService.getSetting(OpEnum.BYTTE_SDK_CONFIG));
                        if (this.channelId == CHANNEL.PORTALALLIES.CODE) {
                            this.startFlow();
                        }
                        else {
                            this.channelCommunicatorService
                                .retreiveAndSetDeviceInfo()
                                .then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                return tslib_1.__generator(this, function (_a) {
                                    if (this.isPostLogin && this.productPreselected) {
                                        this.configurationService.selectProduct(this.productPreselected);
                                        this.configurationService.getProductIsReady().pipe(takeUntil(this._subscriber$)).subscribe(function (isReady) {
                                            if (isReady) {
                                                _this.startFlow();
                                            }
                                        });
                                    }
                                    else {
                                        this.startFlow();
                                    }
                                    return [2 /*return*/];
                                });
                            }); });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.error(err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype.startFlow = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.channelId !== CHANNEL.SUPERAPP.CODE || this.channelId == CHANNEL.PORTALALLIES.CODE)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.navigationService.startFlow(this.abreCuentasService.getPostlogin())];
                    case 1:
                        _a.sent();
                        this.tagReady = true;
                        this.abreCuentasService.setAppLoaded(true);
                        return [3 /*break*/, 3];
                    case 2:
                        this.channelCommunicatorService.retreiveAndSetAppInfo();
                        this.callCyxteraBytte();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype.callCyxteraBytte = function () {
        this.abreCuentasService.setDsbMobileConfig(this.parametersService.getSetting(OpEnum.DSB_MOBILE_SDK_CONFIG));
        this.dsbValidations();
        this.initBytte();
    };
    /* istanbul ignore next */
    /**
     * Validaciones dsb de seguridad de la aplicación en el dispositivo donde esta corriendo
     *
     * *dsb security valitation of the device where the app is running *
     *
     */
    AppComponent.prototype.dsbValidations = function () {
        try {
            var license = this.abreCuentasService.getDsbMobileConfig().licenseKey[this.channelCommunicatorService.getChannelId()];
            var secureUrl = this.abreCuentasService.getDsbMobileConfig().secureUrl;
            this.DSBinitCheck = true;
            this.DSBisSecureByRiskRules = true;
            this.DSBisSecureCertificate = true;
            this.checkDSBResult();
            // this.channelCommunicatorService
            //   .getImpl()
            //   .initDsbLicense(license)
            //   .then(response => {
            //     if (this.reconnectionAttempt(response)) {
            //       return;
            //     }
            //     if (this.rejectForSecurityCompliance(response)) {
            //       return;
            //     }
            //     this.DSBinitCheck = true;
            //     this.channelCommunicatorService
            //       .getImpl()
            //       .isSecureByRiskRules()
            //       .then(response1 => {
            //         if (this.rejectForSecurityCompliance(response1)) {
            //           return;
            //         }
            //         this.DSBisSecureByRiskRules = true;
            //         this.checkDSBResult();
            //       });
            //     this.channelCommunicatorService
            //       .getImpl()
            //       .isSecureCertificate(secureUrl)
            //       .then(response2 => {
            //         if (this.rejectForSecurityCompliance(response2)) {
            //           return;
            //         }
            //         this.DSBisSecureCertificate = true;
            //         this.checkDSBResult();
            //       });
            //   });
        }
        catch (error) {
            console.log(error);
        }
    };
    /* istanbul ignore next */
    /**
     * Validación de intentos de reconexión para el servicio de DSB
     *
     * *reconnection attempt validation for DSB service*
     *
     */
    AppComponent.prototype.reconnectionAttempt = function (dsbResponse) {
        if (dsbResponse.code === '2005') {
            this.dsbConnectionAttempts += 1;
            if (this.dsbConnectionAttempts <=
                this.abreCuentasService.getDsbMobileConfig().connectionMaxAttempts) {
                this.dsbValidations();
                return true;
            }
            this.abreCuentasService.setDsbSecurityCheckException(dsbResponse.code);
            this.tagReady = true;
            this.navigationService.navigateToGeneralInformation('dsbException');
            return true;
        }
        return false;
    };
    /* istanbul ignore next */
    /**
     * Verifica el resultado de DSB en el caso que sea rechazado por una brecha de seguridad
     *
     * *Check DSB result in case it was rejected by a security compliance*
     *
     */
    AppComponent.prototype.rejectForSecurityCompliance = function (dsbResponse) {
        var e_1, _a;
        try {
            // Evaluates if the response code is a blocking one.
            for (var _b = tslib_1.__values(this.abreCuentasService.getDsbMobileConfig()
                .disalloweCodes), _c = _b.next(); !_c.done; _c = _b.next()) {
                var code = _c.value;
                if (dsbResponse.code === code &&
                    !this.navigationService.isGeneralInformationStep) {
                    this.tagReady = true;
                    this.abreCuentasService.setDsbSecurityCheckException(code);
                    this.navigationService.navigateToGeneralInformation('dsbException');
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // Process general exceptions.
        switch (dsbResponse.code) {
            case '404':
            case '9000':
                if (!this.navigationService.isGeneralInformationStep) {
                    this.tagReady = true;
                    this.navigationService.navigateToGeneralInformation('500');
                }
                return true;
        }
        return false;
    };
    /* istanbul ignore next */
    /**
     * Verifica el resultado de DSB(seguridad de la app en el dispositivo) para después crear el flujo de la aplicación
     *
     * *Check DSB (app device security) Result and after creates the flow of the app*
     *
     */
    AppComponent.prototype.checkDSBResult = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.DSBinitCheck &&
                            this.DSBisSecureByRiskRules &&
                            this.DSBisSecureCertificate)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.navigationService.startFlow(this.abreCuentasService.getPostlogin())];
                    case 1:
                        _a.sent();
                        this.tagReady = true;
                        this.abreCuentasService.setAppLoaded(true);
                        return [2 /*return*/, true];
                    case 2: return [2 /*return*/, false];
                }
            });
        });
    };
    /* istanbul ignore next */
    /**
     * Inicializa la configuración Bytte para establecer los parámetros de escaneo de imagenes
     *
     * *Set up Bytte configuration to establish parameters to images scanning*
     *
     */
    AppComponent.prototype.initBytte = function () {
        this.channelCommunicatorService.getImpl().cleanResidualFiles();
        var impl = this.channelCommunicatorService.getImpl();
        var url = impl.registerBytteLicense(this.abreCuentasService.getBytteConfig().licenses[this.channelId]
            .activationURL);
        this.abreCuentasService.setRegisterBytteLicensePromise(url);
    };
    /**
     * Inicializa el estado de icono de cargando de la aplicación
     *
     * *Set Loading State*
     *
     */
    AppComponent.prototype.setLoadingSubscribe = function () {
        var _this = this;
        this.loadingSubscription = this.loadingService.loadingState.subscribe(function (state) { return (_this.showLoading = state); });
    };
    /**
     * Suscribción al observable del header
     *
     * Header observable description
     *
     */
    AppComponent.prototype.setHeaderSubscribe = function () {
        var _this = this;
        this.headerSubscription = this.headerService.headerState.subscribe(function (header) {
            _this.header = header;
            if (_this.headerComponent && _this.header.show) {
                _this.headerComponent.ngOnInit();
            }
            _this.cdRef.detectChanges();
        });
    };
    /**
     * Define la clase principal, donde establece el canal de comunicación para la aplicación
     *
     * *Sets main class, where establishes communication channel for the app*
     *
     */
    AppComponent.prototype.setMainClass = function () {
        var MAIN = 'main';
        this.mainClass = MAIN + "-" + this.channelCommunicatorService.getChannelStyle();
    };
    /**
     * Establece la altura del header
     *
     * *Sets header height*
     */
    AppComponent.prototype.setMainHeight = function () {
        var height = this.header.show ? 3.5 : 0;
        height = height + (this.header.steps ? 2.8 : 0);
        return this.domSanitizer.bypassSecurityTrustStyle("--main-height: " + height + "rem; padding-bottom: 24px");
    };
    /**
     * Establece la altura del header
     *
     * *Sets header height*
     */
    AppComponent.prototype.showFooter = function () {
        return false;
    };
    /**
     * se carga los departamentos
     *
     * *Sets header height*
     */
    AppComponent.prototype.getDistrict = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestService.districtBrances().then(function (response) {
                            _this.abreCuentasService.setDistricts(response.body);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return AppComponent;
}());
export { AppComponent };
